import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const subheaderCollapsible = createSlice({
	name: 'subheaderCollapsible',
	initialState,
	reducers: {
		setVisibleState: (state, { payload }) => ({
			...state,
			[payload.id]: payload.visible,
		}),
		resetAllSubheaderCollapsible: () => ({
			...initialState,
		}),
	},
});

export default subheaderCollapsible.reducer;
export const REDUCER_NAME = subheaderCollapsible.name;

export const { setVisibleState, resetAllSubheaderCollapsible } = subheaderCollapsible.actions;
